import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MRLoginComponent } from './login/login.component';
import { ProjectsComponent } from './projects/projects.component';
import { QuoteComponent } from './quote/quote.component';
import { MRRegisterComponent } from './register/register.component';
import { ChangepasswordComponent } from './changepassword/changepassword.component';
import { RegisterconfirmComponent } from './registerconfirm/registerconfirm.component';
import { ViewerComponent } from './Viewer/viewer.component';
import { ShareviewComponent } from './shareview/shareview.component';
import { UseradminComponent } from './useradmin/useradmin.component';
import { ShapesearchComponent } from './shapesearch/shapesearch.component';
import { ProjectinfoComponent } from './projectinfo/projectinfo.component';
import { WorkspaceComponent } from './workspace/workspace.component';
import { CompareviewComponent } from './compareview/compareview.component';
import { SuperimposeComponent } from './superimpose/superimpose.component';
import { BernieComponent } from './bernie/bernie.component';
import { SetpasswordComponent } from './setpassword/setpassword.component';
import { CustomersComponent } from './customers/customers.component';
import { ResourceadminComponent } from './resourceadmin/resourceadmin.component';
import { MaterialadminComponent } from './materialadmin/materialadmin.component';
import { RecipesComponent } from './recipes/recipes.component';
import { QuotedocumentComponent } from './quotedocument/quotedocument.component';
import { AccountadminComponent } from './accountadmin/accountadmin.component';
import { PdfviewerComponent } from './pdfviewer/pdfviewer.component';
import { AuthGuard } from './cognito/auth.guard';

import { Component } from '@angular/core';
import {
  Location,
  LocationStrategy,
  HashLocationStrategy
} from '@angular/common';

export const appRoutes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: MRLoginComponent },
  { path: 'login/:val', component: MRLoginComponent },
  { path: 'login/:val/:email', component: MRLoginComponent },
  { path: 'register', component: MRRegisterComponent },
  { path: 'changepassword', component: ChangepasswordComponent },
  { path: 'registerconfirm', component: RegisterconfirmComponent },
  { path: 'registerconfirm/:email', component: RegisterconfirmComponent },
  { path: 'setpassword/:email', component: SetpasswordComponent },
  { path: 'setpassword/:email/:code', component: SetpasswordComponent },
  /* AuthGuarded */
  { path: 'quote/:id',  component: QuoteComponent, canActivate: [AuthGuard] },
  { path: 'quote',  component: QuoteComponent, canActivate: [AuthGuard] },
  { path: 'projectinfo/:id', component: ProjectinfoComponent, canActivate: [AuthGuard] },
  { path: 'projects', component: ProjectsComponent, canActivate: [AuthGuard] },
  { path: 'projects/:page', component: ProjectsComponent, canActivate: [AuthGuard] },
  { path: 'shapesearch/:id', component: ShapesearchComponent, canActivate: [AuthGuard] },
  { path: 'viewer', component: ViewerComponent, canActivate: [AuthGuard] },
  { path: 'viewer/:urlString', component: ViewerComponent, canActivate: [AuthGuard] },
  { path: 'shareview', component: ShareviewComponent, canActivate: [AuthGuard] },
  { path: 'shareview/:file', component: ShareviewComponent, canActivate: [AuthGuard] },
  { path: 'useradmin', component: UseradminComponent, canActivate: [AuthGuard] },
  { path: 'workspace', component: WorkspaceComponent, canActivate: [AuthGuard] },
  { path: 'compareview', component: CompareviewComponent, canActivate: [AuthGuard] },
  { path: 'superimpose', component: SuperimposeComponent, canActivate: [AuthGuard] },
  { path: 'bernie', component: BernieComponent, canActivate: [AuthGuard] },
  { path: 'customers', component: CustomersComponent, canActivate: [AuthGuard] },
  { path: 'resourceadmin', component: ResourceadminComponent, canActivate: [AuthGuard] },
  { path: 'materialadmin', component: MaterialadminComponent, canActivate: [AuthGuard] },
  { path: 'quotedocument', component: QuotedocumentComponent, canActivate: [AuthGuard] },
  { path: 'recipes/:id', component: RecipesComponent, canActivate: [AuthGuard] },
  { path: 'accountadmin', component: AccountadminComponent, canActivate: [AuthGuard] },
  { path: 'pdfviewer', component: PdfviewerComponent, canActivate: [AuthGuard] },
  /* Catch-all */
  { path: '**', redirectTo: 'login' }
];

export const appRoutingProviders: any[] = [

];

export const routing = RouterModule.forRoot(appRoutes, { useHash: true });



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/app.routing.ts